import { render } from "./app-system-header.vue?vue&type=template&id=6386bf67&scoped=true"
import script from "./app-system-header.vue?vue&type=script&lang=js"
export * from "./app-system-header.vue?vue&type=script&lang=js"

import "./app-system-header.vue?vue&type=style&index=0&id=6386bf67&lang=scss"
import "./app-system-header.vue?vue&type=style&index=1&id=6386bf67&lang=scss&scoped=true"

import exportComponent from "D:\\shine\\shine-project\\dispatch-big-screen-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6386bf67"]])

export default __exports__